// extracted by mini-css-extract-plugin
module.exports = {"draftLeft":"AlignmentStyles_draftLeft__33G13","draftRight":"AlignmentStyles_draftRight__1ihY2","draftCenter":"AlignmentStyles_draftCenter__3CXRP"};